// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");

function relative(date) {
  return DateFns.formatRelative(date, Date.now());
}

exports.relative = relative;
/* date-fns Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/ffi/DateFormat.re
// module id = 384
// module chunks = 0